// Placeholder for pages built in later phases (User Stories 1–4) — proves the routing/layout
// skeleton works end to end before each page's real content exists.
export function ComingSoon({ title }: { title: string }) {
  return (
    <div className="p-6">
      <h1 className="font-sans text-xl text-ink">{title}</h1>
      <p className="mt-2 text-body">This page is built in a later phase.</p>
    </div>
  );
}
